import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router }       from '@angular/router';
import { LoginService }                 from '@cs/performance-manager/login';

@Component({
	standalone: false,
	selector:    'pmc-request-access-confirmation',
	templateUrl: './confirmation.component.html',
	styleUrls:   ['./confirmation.component.scss']
})
export class RequestAccessConfirmationComponent implements OnInit, OnDestroy {
	/** The case number shown to the user (only relevant for the success/new-request mode). */
	requestId = '';

	/** True when this is a brand-new request (`/confirmation/success`); false for an update (`/confirmation/update`). */
	isNewRequest = true;

	/** Destination for the "Back to login" button — supplied by the wizard finish handler via query params. */
	private backToLoginUrl = '/login';

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private loginService: LoginService
	) {
		// Hide the LoginComponent card-header (logo + "Welkom") so only the
		// confirmation's own header is visible inside the card.
		this.loginService.setHideHeader(true);
	}

	ngOnInit(): void {
		const mode = this.route.snapshot.params['id'] || '';
		this.isNewRequest = mode !== 'update';

		// Query params survive page reloads and avoid the router-state lifetime issues.
		this.requestId      = this.route.snapshot.queryParams['caseNr'] || '';
		this.backToLoginUrl = this.route.snapshot.queryParams['backTo'] || '/login';
	}

	ngOnDestroy(): void {
		// Restore the header when leaving this page so other routes
		// (including the base login route) see the correct state.
		this.loginService.setHideHeader(false);
	}

	goToLogin(): void {
		// `backToLoginUrl` may point outside the Angular base href (e.g. /client/login/),
		// so a hard navigation is needed — `router.navigateByUrl` only works for in-app routes.
		window.location.href = this.backToLoginUrl;
	}
}